import { render } from "./SwzPieChart.vue?vue&type=template&id=01303679&scoped=true"
import script from "./SwzPieChart.vue?vue&type=script&lang=js"
export * from "./SwzPieChart.vue?vue&type=script&lang=js"

import "./SwzPieChart.vue?vue&type=style&index=0&id=01303679&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01303679"]])

export default __exports__